export const FETCH_CSS_INFO = "FETCH_CSS_INFO"
export const FETCH_CSS_INFO_SUCCESS = "FETCH_CSS_INFO_SUCCESS"

